<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'CostCenter_Title' | translateWF: 'Cost Centers' }}</h1>
        <div class="page__title_buttons"></div>
      </div>
      <p class="text-sm text-[var(--p-text-muted-color)]">
        {{ 'CostCenter_Subtitle' | translateWF: 'Read-only. A GL account rule set on a cost center also applies to every cost center below it.' }}
      </p>
    </div>

    <div class="grid grid-cols-12 gap-[2rem]">
      <div class="col-span-12 md:col-span-3 xl:col-span-3">
        @if (filterConfig(); as config) {
          <csl-dynamic-filters [filterConfig]="config" [state]="filterState" />
        }
      </div>

      <div class="col-span-12 md:col-span-9 xl:col-span-9">
        <p class="text-sm text-[var(--p-text-muted-color)] mb-2">{{ matchCount() }} {{ 'CostCenter_Count' | translateWF: 'cost centers' }}</p>
        <p-treetable [value]="treeNodes()" [rowHover]="true">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'CostCenter_Col_CostCenter' | translateWF: 'Cost center' }}</th>
              <th class="text-right" style="width: 7rem">{{ 'CostCenter_Col_Level' | translateWF: 'Level' }}</th>
              <th style="width: 10rem">{{ 'CostCenter_Col_Selectable' | translateWF: 'Selectable' }}</th>
              <th style="width: 9rem">{{ 'Status' | translateWF: 'Status' }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr [ttRow]="rowNode">
              <td>
                <p-treeTableToggler [rowNode]="rowNode" />
                <span class="font-mono mr-2">{{ rowData.code }}</span>
                <span [class.font-semibold]="!rowNode.node.leaf">{{ rowData.name }}</span>
              </td>
              <td class="text-right tabular-nums">{{ rowData.level ?? '—' }}</td>
              <td>
                @if (rowData.selectable) {
                  <p-tag severity="info" [value]="'CostCenter_Selectable_Yes' | translateWF: 'Yes'" />
                } @else {
                  <span class="text-[var(--p-text-muted-color)]">{{ 'CostCenter_Selectable_No' | translateWF: 'No' }}</span>
                }
              </td>
              <td>
                <p-tag
                  [severity]="rowData.isActive ? 'success' : 'secondary'"
                  [value]="rowData.isActive ? ('CostCenter_Active' | translateWF: 'Active') : ('CostCenter_Inactive' | translateWF: 'Inactive')"
                />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" class="text-center">{{ 'CostCenter_Empty' | translateWF: 'No cost centers found.' }}</td>
            </tr>
          </ng-template>
        </p-treetable>
      </div>
    </div>
  </div>
</main>
